// extracted by mini-css-extract-plugin
export default {"label":"formTextarea_label__cuS0g","textarea":"formTextarea_textarea__D2r-S","textareaLarge":"formTextarea_textareaLarge__A7zcl"};